import { PortalUser } from '@epilot/customer-portal-client'

export const MOCK_PORTAL_USER: { data: PortalUser } = {
  data: {
    access_status: true,
    email: [
      {
        _tags: ['primary'],
        email: 'user@example.com',
        _id: 'qw52_etAZefe0j44VqJ8W'
      }
    ],
    origin: 'END_CUSTOMER_PORTAL',
    registration_status: 'Registered',
    mapping_status: 'Mapped',
    mapped_contact: {
      $relation: [
        {
          entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
          _schema: 'contact',
          _tags: []
        }
      ]
    },
    _schema: 'portal_user',
    _id: '42c6e2af-145a-416d-b766-62b1fc2b0ffa',
    _org: '16246022',
    _created_at: '2025-05-20T08:30:31.852Z',
    _updated_at: '2025-05-23T06:37:40.823Z',
    _title: 'user@example.com',
    password: null,
    _tags: ['dont-touch']
  }
}
